export enum FooterType {
  Common = 'COMMON',
  ContentHome = 'CONTENT_HOME',
  DayOfWeek = 'DAY_OF_WEEK',
}
